module.exports = "/_next/static/images/banner_icon_recruit-eaff294efc9e7ad07c8c2c0877470183.svg";